// extracted by mini-css-extract-plugin
export var btn = "J_t y_s5 y_sQ g_cD g_cS g_cH g_fz";
export var full = "J_wy g_bD g_bP";